import { render } from "./PayStatus.vue?vue&type=template&id=61704530"
import script from "./PayStatus.vue?vue&type=script&lang=js"
export * from "./PayStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__